import {
  FormAutocomplete,
  FormCheckbox,
  FormDatePicker,
  FormEmailTokens,
  FormMultiSelect,
  FormNumberInput,
  FormPasswordInput,
  FormRadio,
  FormSelect,
  FormSwitch,
  FormTextarea,
  FormTextInput,
  SubmitButton,
} from '@/library/form/components';

/**
 * Field components exposed on `form.AppField` render props (`field.TextInput`
 * etc.). Later tickets extend this registry as needed (tag inputs, address
 * select, server-search autocomplete — see gpm-webapp-v2's `fieldComponents`).
 */
export const appFieldComponents = {
  TextInput: FormTextInput,
  PasswordInput: FormPasswordInput,
  NumberInput: FormNumberInput,
  Textarea: FormTextarea,
  Select: FormSelect,
  MultiSelect: FormMultiSelect,
  EmailTokens: FormEmailTokens,
  Autocomplete: FormAutocomplete,
  Checkbox: FormCheckbox,
  Switch: FormSwitch,
  Radio: FormRadio,
  DatePicker: FormDatePicker,
};

/** Form-level components exposed on `form.AppForm` (`<form.SubmitButton/>`). */
export const appFormComponents = {
  SubmitButton,
};
